import { gsap, ScrollTrigger, ScrollToPlugin } from "gsap/all.js";

// set up gsap and scrollmagic
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

class ScrollManager {
  // -- PUBLIC -- //

  scrollToAnchor = (anchor, jump) => {
    const time = jump ? 0 : 0.5;
    gsap.to(window, time, { scrollTo: { y: anchor, offsetY: 100 } });

    if (window.history && window.history.pushState) {
      history.pushState("", document.title, anchor.substring(1));
    }
  };

  scrollToAnchorEvent = evt => {
    if (typeof evt === "string") {
      console.warn(
        "ScrollManager.scrollToAnchorEvent :: use scrollToAnchor() to jump directly to anchor string"
      );
      return null;
    }

    evt.preventDefault();

    const anchor = evt.target.getAttribute("href");
    this.scrollToAnchor(anchor);
  };

  // -- INIT -- //

  init() {
    gsap.utils
      .toArray([
        "#parallax0",
        "#parallax1",
        "#parallax2",
        "#parallax3",
        "#parallax4",
        "#parallax5"
      ])
      .forEach((section, i) => {
        section.bg = section.querySelector(".parallax-image");

        // Do the parallax effect on each section
        if (section.bg) {
          section.bg.style.backgroundPosition = `50% 40px`;

          gsap.to(section.bg, {
            backgroundPosition: `50% ${innerHeight / 2}px`,
            ease: "none",
            scrollTrigger: {
              trigger: section,
              scrub: true
            }
          });
        }
      });
  }
}

export default ScrollManager;
